export default "__VITE_ASSET__uCVc02Yj__"